import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { HeadingType } from '@freelancer/ui/heading';
import { IconSize } from '@freelancer/ui/icon';
import { LinkIconPosition } from '@freelancer/ui/link';
import { Margin } from '@freelancer/ui/margin';
import { FontColor, TextSize } from '@freelancer/ui/text';

@Component({
  selector: 'app-user-profile-expert-communities-badge',
  template: `
    <fl-bit [flMarginBottom]="Margin.MID">
      <fl-heading
        i18n="Expert Community Certification Title"
        [headingType]="HeadingType.H2"
      >
        {{ community }}
      </fl-heading>
    </fl-bit>
    <fl-bit class="CommunityBadges">
      <fl-picture
        class="CommunityBadges-picture"
        alt="Expert Community Certification Badge Image"
        i18n-alt="Expert Community Certification Badge Image"
        [src]="badgeSrc"
      >
      </fl-picture>
      <fl-bit>
        <fl-text
          i18n="Expert Community Certification Badge Name"
          [size]="TextSize.SMALL"
          [flMarginBottom]="Margin.XXSMALL"
        >
          {{ certificationName }}
        </fl-text>
        <fl-bit class="CommunityBadges-issuer">
          <fl-text
            i18n="Expert Community Certification Badge Issued By"
            [color]="FontColor.MID"
            [flMarginRightTablet]="Margin.XXXSMALL"
          >
            Issued by
          </fl-text>
          <fl-link
            i18n="Expert Community Certification Badge Issued By Company"
            [flTrackingLabel]="trackingLabel"
            [iconName]="'ui-exit'"
            [iconPosition]="LinkIconPosition.RIGHT"
            [iconSize]="IconSize.XSMALL"
            [link]="link"
          >
            {{ issuer }}
          </fl-link>
        </fl-bit>
      </fl-bit>
    </fl-bit>
  `,
  styleUrls: ['./user-profile-expert-communities-badge.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserProfileExpertCommunitiesBadgeComponent {
  FontColor = FontColor;
  TextSize = TextSize;
  HeadingType = HeadingType;
  IconSize = IconSize;
  LinkIconPosition = LinkIconPosition;
  Margin = Margin;

  @Input() badgeSrc: string;
  @Input() community: string;
  @Input() certificationName: string;
  @Input() issuer: string;
  @Input() link: string;
  @Input() trackingLabel: string;
}
